import Crud from '../crud'
let crud = new Crud('/rest/alertconditiontypes', {
  rowsProp: false
})

export default {
  namespaced: true,
  state: {
    loading: false,
    data: []
  },
  getters: {
    ...crud.getters
  },
  mutations: {
    ...crud.mutations
  },
  actions: {
    ...crud.actions,
    async find (stuff) {
      // Find all at once
      return crud.actions.find(stuff, { rowCount: 1000 })
    },
    empty: {
      root: true,
      async handler ({ commit }) {
        commit('setData', [])
      }
    }
  }
}
